/**
 * Copyright (c) 2025, CheckPlus Limited
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import "./Sidebar.css";

// The sections of the current workspace. Below 900px it turns into a
// horizontal strip above the content and the card at the foot is dropped.
class Sidebar extends Component {
  render() {
    const vm = this.props.vm;
    return (
      <div className="Marketplace-Sidebar">
        <div className="Marketplace-Sidebar-label">{vm.m.sectionsLabel}</div>
        <div className="Marketplace-Sidebar-nav">
          {/* News is out of a donor's sidebar while the feed is finished off —
              see NOT_READY in Marketplace.js. The section itself still exists,
              so nothing else has to know. */}
          {vm.nav
            .filter((n) => n.id !== "inbox" || !vm.isIndividual || vm.showDonorNews)
            .map((n) => (
              <div
                className={"Marketplace-Sidebar-item" + (n.active ? " Marketplace-Sidebar-item--active" : "")}
                onClick={n.go}
                key={n.id}
                /* What the guided tour spotlights (CP-308). Every row carries
                   one rather than only the rows a step currently names: the
                   attribute costs nothing, and a catalogue that grows should
                   not need this file reopened each time. */
                data-tour={"nav-" + n.id}
              >
                <span className="Marketplace-Sidebar-dot" />
                <span className="Marketplace-Sidebar-itemLabel">{n.label}</span>
                {/* Nonprofit news, while something is unread. The view model
                  returns null at zero rather than "0" — a badge saying there
                  is nothing to see is worse than no badge. */}
                {!!n.badge && (
                  <span className="Marketplace-Sidebar-badge">{n.badge}</span>
                )}
              </div>
            ))}
        </div>
        <div className="Marketplace-Sidebar-card">
          <div className="Marketplace-Sidebar-cardTitle">{vm.railTitle}</div>
          <div className="Marketplace-Sidebar-cardBody">{vm.railBody}</div>
        </div>
        {/* Below the card, at the very foot of the column, where the design
            puts it. Only a workspace with a tour written for it has a label
            here; the other two draw nothing at all. */}
        {!!vm.tourReplayLabel && (
          <div className="Marketplace-Sidebar-replay" onClick={vm.tourReplayRun}>
            <span className="Marketplace-Sidebar-replayIcon">&#8635;</span>
            {vm.tourReplayLabel}
          </div>
        )}
      </div>
    );
  }
}

Sidebar.propTypes = {
  vm: PropTypes.object.isRequired,
};

export default Sidebar;
